import {NodeOutputData} from 'common/src/modules/nodes/nodes.types';
import {OutputType} from 'common/src/modules/nodes/nodes.types';

export default function getOutputTypePhrase(output: NodeOutputData): string {
  switch (output.type) {
    case OutputType.Regular:
      return '(selection succeeded)';
    case OutputType.Fallback:
      return '(selection failed)';
    case OutputType.Last:
      return '(last output)';
    case OutputType.PartialSuccess:
      return '(partial success, not enough products selected)';
    default:
      return '(selection failed)';
  }
}
